import React from "react";
import { motion } from "framer-motion";

function Spinner(props) {
  return (
    <motion.div 
        className="absolute w-100 h-100 top-0 left-0 flex items-center justify-center z-999 usn bg-white-20"
        initial={{ opacity: 0}}
        animate={{ opacity: 1}}
        transition={{ ease: "easeOut", duration: 0.1 }}
        >
        <div className="loader-container">
            <div className="loader">{props.i18n['loading']}</div>
        </div>
    </motion.div>
  );
}

export default Spinner;
